module.exports = __webpack_public_path__ + "img/dffa.0b88586a.png";